const generateFlagKey = (language: string): string => {
  switch (language) {
    case "en":
      return "EnUs";
    case "pt-pt":
      return "Pt";
    default:
      return language.replace(/^[a-z]|-[a-z]/g, (match) => match.toUpperCase()).replace("-", "");
  }
};

export default generateFlagKey;
